import React from 'react';
import { Stack, themeVars } from '@eds-web/react';
import { TaxDocumentSelection } from './TaxDocumentSelection';
import { Divider } from '@mui/material';
import { useSelector } from 'react-redux';

import { TaxDocumentDownloadList } from './TaxDocumentDownloadList';
import { selectNoTaxProfile } from '../../selectors/tax.selector';
import { useTaxProfileForm } from '../../hooks/useTaxProfileForm';

export const TaxDocument = () => {
    const noTaxProfile = useSelector(selectNoTaxProfile);
    const { showGuardianForm } = useTaxProfileForm();
    return (
        <Stack gap={32}>
            <TaxDocumentSelection />
            <TaxDocumentDownloadList />
            {Boolean(!noTaxProfile || showGuardianForm) && (
                <Divider
                    style={{
                        margin: '0 0 32px 0',
                        borderColor: themeVars.color.transparent.light['015']
                    }}
                />
            )}
        </Stack>
    );
};
